var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/chrome/super-user-banner.html';
var html = "<div ng-if=\"::$ctrl.isSuperUser\">\n  <div id=\"super-user-banner\">\n    <span translate=\"SUPER_USER_MESSAGE_{{::$ctrl.isMR ? 'MR' : 'EI'}}\"></span>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;